import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, renderSlot as _renderSlot, vModelCheckbox as _vModelCheckbox, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-sm btn-light-info btn-active-light-info mx-1",
  "data-kt-menu-target": "#kt-export-menu",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mb-1" }),
  /*#__PURE__*/_createTextVNode(" Dışa Aktar ")
], -1)
const _hoisted_6 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px p-3",
  "data-kt-menu": "true",
  id: "kt-export-menu"
}
const _hoisted_7 = { class: "menu-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel text-success mb-1 mx-1" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Excel ")
const _hoisted_10 = { class: "menu-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel text-success mb-1 mx-1" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Excel (Tüm veri) ")
const _hoisted_13 = {
  key: 2,
  class: "d-flex align-items-center",
  style: {"margin-left":"auto"}
}
const _hoisted_14 = { class: "fw-bolder me-5" }
const _hoisted_15 = { class: "me-2" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Seçili ")
const _hoisted_17 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_18 = ["value"]

import {
  ref,
  onMounted,
  watch,
  watchEffect,
} from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { IPagination, defaultPagination } from "@/core/models/PageModel";
import JsonExcel from "vue-json-excel3";
import MenuComponent from "@/components/menu/MenuComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AsDataTable',
  props: {
  id: {
    type: String,
    default: "datatable",
  },
  items: {
    type: [Array, Function],
    default: () => [],
  },
  header: {
    type: Array,
    default: () => [],
    required: true,
  },
  checkableColumn: {
    type: Boolean,
    default: () => false,
  },
  selectedRowActive: {
    type: Boolean,
    default: () => false,
  },
  checkColumnValue: {
    type: String,
    default: () => "id",
  },
  enableItemsPerPageDropdown: {
    type: Boolean,
    default: () => true,
  },
  noPagination: {
    type: Boolean,
    default: () => false,
  },
  searchable: {
    type: Boolean,
    default: () => true,
  },
  exportable: {
    type: Boolean,
    default: () => true,
  },
},
  emits: ["row-click"],
  setup(__props, { expose, emit: emits }) {

const props = __props





let tableData = ref([]);
let tableHeader = ref(props.header);
const loading = ref<boolean>(false);
const enablePerPageDropdown = ref<boolean>(props.enableItemsPerPageDropdown);
const pagination = ref<IPagination>({ ...defaultPagination });
const checkedItems = ref([]);
const checkedRows = ref([]);
const exportFields = ref({});
onMounted(() => {
  tableHeader.value = tableHeader.value.filter((s) => s.show != false);

  tableHeader.value.forEach((s) => {
    if (s.exportable == undefined || s.exportable == true) {
      if (
        s.exportCallback != undefined &&
        typeof s.exportCallback === "function"
      ) {
        exportFields.value = Object.assign(exportFields.value, {
          [s.name]: { callback: s.exportCallback },
        });
      } else {
        exportFields.value = Object.assign(exportFields.value, {
          [s.name]: s.key,
        });
      }
    }
  });
  if (props.noPagination) {
    pagination.value.take = 99999;
    enablePerPageDropdown.value = false;
  }
  if (
    props.checkableColumn &&
    tableHeader.value.map((s) => s.key).indexOf("checkbox") == -1
  ) {
    var checkedheader = {
      key: "checkbox",
      sortable: false,
    };
    tableHeader.value.splice(0, 0, checkedheader);
  }
});

const getData = async (type = "default") => {
  try {
    loading.value = true;
    if (typeof props.items === "function") {
      if (type.startsWith("export")) {
        const exportData = await props.items({
          take: type == "export-all" ? 1000000 : pagination.value.take,
          page: type == "export-all" ? 0 : pagination.value.page,
          search: pagination.value.search,
          total: 0,
        });

        return exportData.list;
      } else {
        let items = await props.items(pagination.value);
        if (items == undefined || items.length == 0) {
          items = { list: [] };
        }
        tableData.value.splice(0, tableData.value.length, ...items.list);
        if (!props.noPagination) {
          pagination.value.total = items.totalCount;
        }
      }
    } else {
      tableData.value.splice(0, tableData.value.length, ...props.items);

      if (type != "default") {
        return tableData.value;
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};

const refresh = () => {
  getData();
  checkedClear();
};
const setPage = (data) => {
  pagination.value.page = data == 0 ? data : data - 1;
  getData();
};
const setItemsPerPage = (data) => {
  pagination.value.take = data;
  getData();
};
const search = (data) => {
  pagination.value.search = data;
  pagination.value.page = 0;
  getData();
};
const checkedClear = () => {
  checkedItems.value.length = 0;
};
const getcheckedRow = () => {
  var newchecked = checkedItems.value.filter(
    (i) => !checkedRows.value.find((s) => s[props.checkColumnValue] == i)
  );
  for (var i = 0; i < newchecked.length; i++) {
    checkedRows.value.push(
      tableData.value.find((s) => s[props.checkColumnValue] == newchecked[i])
    );
  }
};
const currentData = () => {
  return tableData.value;
};

const onSort = (data) => {
  pagination.value.orderBy = data.columnName;
  pagination.value.direction = data.order;
  getData();
};

const rowClick = (data) => {
  emits("row-click", data);
};

const allChecked = (data) => {
  if (data) {
    checkedItems.value = tableData.value.map((s) => s[props.checkColumnValue]);
  } else {
    checkedClear();
  }
};
watchEffect(() => props.items, getData());
watch(
  () => props.items,
  () => {
    getData();
  }
);
watch(
  () => checkedItems.value,
  () => getcheckedRow()
);
expose({ refresh, checkedClear, currentData });

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.searchable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid w-250px ps-15",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pagination.value.search) = $event)),
              placeholder: "Ara"
            }, null, 512), [
              [_directive_debounce, search, "400ms"],
              [_vModelText, pagination.value.search]
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.exportable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(MenuComponent, { "menu-selector": "#kt-export-menu" }, {
              toggle: _withCtx(() => [
                _hoisted_5
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(JsonExcel), {
                      fetch: async () => await getData('export'),
                      fields: exportFields.value,
                      class: "menu-link"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["fetch", "fields"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(JsonExcel), {
                      fetch: async () => await getData('export-all'),
                      fields: exportFields.value,
                      class: "menu-link"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["fetch", "fields"])
                  ])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (checkedItems.value.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(checkedItems.value.length), 1),
              _hoisted_16
            ]),
            _renderSlot(_ctx.$slots, "checked-toolbar", {
              items: checkedItems.value,
              rows: checkedRows.value
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Datatable, {
      id: props.id,
      loading: loading.value,
      tableHeader: _unref(tableHeader),
      tableData: _unref(tableData),
      total: pagination.value.total,
      onCurrentChange: setPage,
      onItemsPerPageChange: setItemsPerPage,
      rowsPerPage: pagination.value.take,
      enableItemsPerPageDropdown: enablePerPageDropdown.value,
      onSort: onSort,
      onRowClick: rowClick,
      onAllChecked: allChecked,
      selectedRowActive: props.selectedRowActive
    }, _createSlots({ _: 2 }, [
      (props.checkableColumn)
        ? {
            name: "cell-checkbox",
            fn: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: row[props.checkColumnValue],
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkedItems).value = $event))
                }, null, 8, _hoisted_18), [
                  [_vModelCheckbox, checkedItems.value]
                ])
              ])
            ])
          }
        : undefined,
      _renderList(_ctx.$slots, (_, name) => {
        return {
          name: name,
          fn: _withCtx((slotData) => [
            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)))
          ])
        }
      })
    ]), 1032, ["id", "loading", "tableHeader", "tableData", "total", "rowsPerPage", "enableItemsPerPageDropdown", "selectedRowActive"])
  ], 64))
}
}

})